export const persianToEnglishNumbers = (value) => {
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arabicNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  return value
    .split('')
    .map((char) =>
      persianNumbers.includes(char)
        ? arabicNumbers[persianNumbers.indexOf(char)]
        : char
    )
    .join('');
};
